<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Soutien" />
            <Soutiens />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import Soutiens from '../Soutien/SouTiens.vue'

export default {
    name: 'SoutienPage',
    components: {
        NavBar,
        PageTitle,
        Soutiens,
        FooterComp,
    }
}
</script>